import { Instagram, Facebook } from "lucide-react";
import { Overline, Reveal, MaskLine, ArrowLink } from "./shared";
import { useLang } from "@/i18n";

export default function Gallery() {
  const { t } = useLang();

  return (
    <section id="gallery" className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32" data-testid="gallery-section">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Overline>{t("gallery.overline")}</Overline>
          <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl">
            <MaskLine>{t("gallery.title1")}</MaskLine>
            <MaskLine delay={0.12}>
              <span className="italic text-terracotta">{t("gallery.title2")}</span>
            </MaskLine>
          </h2>
        </div>
        <Reveal delay={0.2}>
          <div className="flex flex-wrap gap-8">
            <ArrowLink href="https://www.instagram.com/arniveda.farm/" testId="instagram-follow-link">
              <span className="inline-flex items-center gap-2">
                <Instagram className="h-4 w-4" /> {t("gallery.follow")}
              </span>
            </ArrowLink>
            <ArrowLink href="https://www.facebook.com/arniveda.farm" testId="facebook-follow-link">
              <span className="inline-flex items-center gap-2">
                <Facebook className="h-4 w-4" /> {t("extras.followFb")}
              </span>
            </ArrowLink>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-2">
        <Reveal delay={0.15}>
          <div className="overflow-hidden border border-ink/10 bg-white" data-testid="instagram-feed-embed">
            <iframe
              src="https://www.instagram.com/arniveda.farm/embed"
              title="Arniveda on Instagram — @arniveda.farm"
              className="h-[640px] w-full"
              loading="lazy"
              frameBorder="0"
              scrolling="yes"
            />
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-moss">
            {t("gallery.caption")}
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="relative overflow-hidden border border-ink/10 bg-white" data-testid="facebook-feed-embed">
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Farniveda.farm&tabs=timeline&width=500&height=640&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
              title="Arniveda on Facebook — arniveda.farm"
              className="h-[640px] w-full"
              loading="lazy"
              frameBorder="0"
              scrolling="yes"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />
            <a
              href="https://www.facebook.com/arniveda.farm"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="facebook-open-page-link"
              className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-2 bg-cream/95 px-4 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-ink backdrop-blur-sm transition-colors hover:bg-mustard"
            >
              <Facebook className="h-4 w-4" /> {t("extras.followFb")}
            </a>
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-moss">
            {t("extras.fbCaption")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
